export default __webpack_public_path__ + "static/media/bubble3.60f75744.mp3";